// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { SeatIcon } from '@10xLabs/react-web/components/Icons/Seat'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { DriverIcon } from '@10xLabs/react-web/components/Icons/Driver'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { DoorIcon } from '@10xLabs/react-web/components/Icons/Door'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { WcIcon } from '@10xLabs/react-web/components/Icons/Wc'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { StairIcon } from '@10xLabs/react-web/components/Icons/Stair'
import { VEHICLE_COMPONENT } from 'features/VehicleTemplates/components/Components/constants'

export const ComponentIcon = ({ component, ...props }: TSFixMe): TSFixMe => {
  switch (component) {
    case VEHICLE_COMPONENT.SEAT:
      return <SeatIcon {...props} />
    case VEHICLE_COMPONENT.DRIVER:
      return <DriverIcon {...props} />
    case VEHICLE_COMPONENT.DOOR:
      return <DoorIcon {...props} />
    case VEHICLE_COMPONENT.WC:
      return <WcIcon {...props} />
    case VEHICLE_COMPONENT.STAIRCASE:
      return <StairIcon {...props} />
  }

  return null
}
